var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDialIndicator = function SvgDialIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "236px",
    height: "236px",
    viewBox: "0 0 236 236",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 236,
    id: "artboard_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artboard_1",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DialIndicator",
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(92 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0ZM25 12.0001C17.8203 12.0001 12 17.8204 12 25.0001C12 32.1798 17.8203 38.0001 25 38.0001C32.1797 38.0001 38 32.1798 38 25.0001C38 17.8204 32.1797 12.0001 25 12.0001Z",
    transform: "translate(0 61)",
    id: "Combined-Shape",
    fill: "#787878",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0L22 64L0 64L11 0Z",
    transform: "translate(14 0)",
    id: "Triangle",
    fill: "#787878",
    fillRule: "evenodd",
    stroke: "none"
  })))));
};

export { SvgDialIndicator as ReactComponent };
export default __webpack_public_path__ + "static/media/DialIndicator.4a9f8a91.svg";